/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('OffersManager', OffersManager);

function OffersManager() {
  var SORT_METHOD_AVAILABILITY_DESC = 'availability_desc';
  var SORT_METHOD_AVAILABILITY_ASC = 'availability_asc';
  var SORT_METHOD_ALPHABETICALLY_DESC = 'alphabetically_desc';
  var SORT_METHOD_ALPHABETICALLY_ASC = 'alphabetically_asc';
  var SORT_METHOD_OWN_CONFIGURATION = 'own_configuration';
  var SORT_ASCENDING = 'ASC';
  var SORT_DESCENDING = 'DESC';

  var $this = this;
  $this.minPersons = null;
  $this.onlyAvailableRooms = false;
  $this.onlyAvailableRateplans = false;
  $this.lengthOfStay = null;
  $this.roomGroupId = null;
  $this.rateplanId = null;
  $this.sortMethod = SORT_METHOD_AVAILABILITY_DESC;
  $this.sortMethods = [
    SORT_METHOD_AVAILABILITY_DESC,
    SORT_METHOD_AVAILABILITY_ASC,
    SORT_METHOD_ALPHABETICALLY_DESC,
    SORT_METHOD_ALPHABETICALLY_ASC,
    SORT_METHOD_OWN_CONFIGURATION
  ];

  function setMinPersons(minPersons) {
    $this.minPersons = parseInt(minPersons, 10);
  }

  function setOnlyAvailableRooms(boolean) {
    $this.onlyAvailableRooms = boolean;
  }

  function setOnlyAvailableRateplans(boolean) {
    $this.onlyAvailableRateplans = boolean;
  }

  function setLengthOfStay(days) {
    $this.lengthOfStay = days;
  }

  function setRoomGroupId(id) {
    $this.roomGroupId = id;
  }

  function setRateplanId(id) {
    $this.rateplanId = id;
  }

  function setSortMethod(method) {
    if (isValidSortMethod(method)) {
      $this.sortMethod = method;
    } else {
      $this.sortMethod = SORT_METHOD_AVAILABILITY_DESC;
    }
  }

  function isValidSortMethod(method) {
    if (!angular.isString(method)) {
      return false;
    }

    return $this.sortMethods.indexOf(method) !== -1;
  }

  function getAvailable(offers) {
    offers = angular.copy(offers);
    var result = [];

    angular.forEach(offers, function (offer) {
      var room = offer.room;
      var rateplans = offer.rateplans;

      if ($this.rateplanId) {
        rateplans = rateplans.filter(function (rateplan) {
          return rateplan.id === $this.rateplanId;
        });
      }

      if ($this.roomGroupId && $this.roomGroupId !== room.id) {
        return;
      }

      if ($this.onlyAvailableRooms && !isRoomAvailable(room)) {
        return;
      }

      rateplans = sortRateplans(rateplans);

      if ($this.onlyAvailableRateplans) {
        rateplans = getAvailableRateplans(rateplans);
      }

      if ($this.minPersons) {
        if (!canRoomHoldPeople(room, $this.minPersons)) {
          return;
        }
        rateplans = getRateplansForPeople(rateplans, $this.minPersons);
      }

      if (!existRateplans(rateplans)) {
        return;
      }

      result.push({
        room: room,
        rateplans: rateplans
      });
    });
    return sort(result);
  }

  function sort(offers) {
    var availableOffers = getAvailableOffers(offers);
    var unavailableOffers = getUnavailableOffers(offers);
    switch ($this.sortMethod) {
      case SORT_METHOD_AVAILABILITY_ASC:
        return sortOffersByAvailability(offers, SORT_ASCENDING);

      case SORT_METHOD_AVAILABILITY_DESC:
        return sortOffersByAvailability(offers, SORT_DESCENDING);

      case SORT_METHOD_ALPHABETICALLY_ASC:
        availableOffers = sortOffersByAlphabetically(availableOffers, SORT_ASCENDING);
        unavailableOffers = sortOffersByAlphabetically(unavailableOffers, SORT_ASCENDING);
        return availableOffers.concat(unavailableOffers);

      case SORT_METHOD_ALPHABETICALLY_DESC:
        availableOffers = sortOffersByAlphabetically(availableOffers, SORT_DESCENDING);
        unavailableOffers = sortOffersByAlphabetically(unavailableOffers, SORT_DESCENDING);
        return availableOffers.concat(unavailableOffers);

      case SORT_METHOD_OWN_CONFIGURATION:
        availableOffers = sortOffersByOwnConfiguration(availableOffers);
        unavailableOffers = sortOffersByOwnConfiguration(unavailableOffers);
        return availableOffers.concat(unavailableOffers);

      default:
        return sortOffersByAvailability(offers, SORT_DESCENDING);
    }
  }

  function sortOffersByAvailability(offers, direction) {
    direction = direction.toUpperCase();
    return offers.sort(function (a, b) {
      if (a.room.availableUnits < b.room.availableUnits) {
        return direction === SORT_DESCENDING ? 1 : -1;
      }
      if (a.room.availableUnits > b.room.availableUnits) {
        return direction === SORT_DESCENDING ? -1 : 1;
      }
      return 0;
    });
  }

  function sortOffersByAlphabetically(offers, direction) {
    direction = direction.toUpperCase();
    return offers.sort(function (a, b) {
      if (a.room.name < b.room.name) {
        return direction === SORT_DESCENDING ? 1 : -1;
      }
      if (a.room.name > b.room.name) {
        return direction === SORT_DESCENDING ? -1 : 1;
      }
      return 0;
    });
  }

  function sortOffersByOwnConfiguration(offers) {
    return offers.sort(function (a, b) {
      if (a.room.position < b.room.position) {
        return -1;
      }
      if (a.room.position > b.room.position) {
        return 1;
      }
      return 0;
    });
  }

  function sortRateplans(rateplans) {
    var availableRateplans = getAvailableRateplans(rateplans);
    var availableRateplanIds = availableRateplans.map(function (rateplan) {
      return rateplan.id;
    });
    var unavailableRateplans = rateplans.filter(function (rateplan) {
      return !availableRateplanIds.includes(rateplan.id);
    });

    return availableRateplans.concat(unavailableRateplans);
  }

  function getAvailableOffers(offers) {
    return offers.filter(function (offer) {
      return offer.room.availableUnits > 0;
    });
  }

  function getUnavailableOffers(offers) {
    return offers.filter(function (offer) {
      return offer.room.availableUnits <= 0;
    });
  }

  function existRateplans(rateplans) {
    return rateplans.length > 0;
  }

  function isRoomAvailable(room) {
    return room.availableUnits > 0;
  }

  function canRoomHoldPeople(room, people) {
    return room.maxPersons >= people;
  }

  function getAvailableRateplans(rateplans) {
    var result = [];
    for (var i = 0; i < rateplans.length; i++) {
      var rateplan = rateplans[i];
      var fulfillMinStay = true;
      var fulfillMaxStay = true;
      if ($this.lengthOfStay && rateplan.minStay !== 0) {
        fulfillMinStay = $this.lengthOfStay >= rateplan.minStay;
      }
      if ($this.lengthOfStay && rateplan.maxStay !== 0) {
        fulfillMaxStay = $this.lengthOfStay <= rateplan.maxStay;
      }
      var isAvailable = fulfillMinStay && fulfillMaxStay;
      if (isAvailable) {
        result.push(rateplan);
      }
    }
    return result;
  }

  function getRateplansForPeople(parsedRateplans, people) {
    var result = [];
    for (var i = 0; i < parsedRateplans.length; i++) {
      var rateplan = parsedRateplans[i];
      var prices = {};
      for (var j = 0; j < rateplan.prices.length; j++) {
        var price = rateplan.prices[j];
        if (price.personsCount === people) {
          prices.price = price.price;
          prices.discountPrice = price.discountPrice;
          prices.regularFee = price.regularFee;
        }
      }
      if (angular.isUndefined(prices.price)) {
        prices.price = rateplan.prices[0].price;
        prices.discountPrice = rateplan.prices[0].discountPrice;
        prices.regularFee = rateplan.prices[0].regularFee;
      }
      rateplan.prices = prices;
      result.push(rateplan);
    }
    return result;
  }

  return {
    setMinPersons: setMinPersons,
    setOnlyAvailableRooms: setOnlyAvailableRooms,
    setOnlyAvailableRateplans: setOnlyAvailableRateplans,
    setLengthOfStay: setLengthOfStay,
    setRoomGroupId: setRoomGroupId,
    setRateplanId: setRateplanId,
    setSortMethod: setSortMethod,
    getAvailable: getAvailable
  };
}
